'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../components/MultiValue');

var _transitions = require('./transitions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// strip transition props off before spreading onto actual component
var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ['in', 'onExited']);

    return _react2.default.createElement(
      _transitions.Collapse,
      { 'in': inProp, onExited: onExited },
      _react2.default.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

exports.default = AnimatedMultiValue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-select/lib/animated/MultiValue.js
 ** module id = 871
 ** module chunks = 0
 **/